import React from 'react';

const About = () => {
  return (
    <div className="page">
      <h1>About Us</h1>
      <p>Learn more about Heretic Studio</p>
    </div>
  );
};

export default About;
